// extracted by mini-css-extract-plugin
export default {"add__button":"Dashboard_add__button__5YmvR","dashboard":"Dashboard_dashboard__CM5BJ"};